import { useMutation } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { useCallApi } from '@/hooks/useCallApi';
import { MutationOptions } from '@/models';
import { fakeNetworkResponse } from '@/utils';

// Mirrors backend src/apis/app/model/req/recruitment_org/update_worker_req.go.
// work_start_date is required when recruitment_status_id = 'TRANG-THAI-TUYEN-DUNG-NLD-08'
// (CD_ARRIVED) per V1.4 B3; BE returns 422 WORK_START_DATE_REQUIRED otherwise.
export interface UpdateWorkerInPlanReq {
  plan_id: string;
  worker_id: string;
  recruitment_status_id: string;
  note?: string;
  work_start_date?: string; // YYYY-MM-DD; only when CD_ARRIVED
}

function endpoint() {
  return '/recruitment-org/update-worker';
}

export function useUpdateWorkerInPlan(options?: MutationOptions<boolean, UpdateWorkerInPlanReq>) {
  const { handleCallApi } = useCallApi();

  function handler(form: UpdateWorkerInPlanReq) {
    return handleCallApi(
      async () => {
        await axiosClient.patch(endpoint(), form);

        return fakeNetworkResponse(true);
      },
      true,
      'Cập nhật trạng thái NLĐ thành công'
    );
  }

  return useMutation(handler, options);
}

// Spec mapping helper — keep in sync with backend status_fsm.go.
export const RECRUITMENT_STATUS = {
  UNCLASSIFIED: 'TRANG-THAI-TUYEN-DUNG-NLD-01',
  POTENTIAL: 'TRANG-THAI-TUYEN-DUNG-NLD-02',
  NOT_POTENTIAL: 'TRANG-THAI-TUYEN-DUNG-NLD-03',
  WAITING_ARRIVE: 'TRANG-THAI-TUYEN-DUNG-NLD-04',
  NOT_ARRIVED: 'TRANG-THAI-TUYEN-DUNG-NLD-05',
  NOT_QUALIFIED: 'TRANG-THAI-TUYEN-DUNG-NLD-06',
  FACTORY_FULL: 'TRANG-THAI-TUYEN-DUNG-NLD-07',
  ARRIVED: 'TRANG-THAI-TUYEN-DUNG-NLD-08',
  LEFT: 'TRANG-THAI-TUYEN-DUNG-NLD-09',
} as const;

// Map status code -> Vietnamese label for UI display.
export const RECRUITMENT_STATUS_LABELS: Record<string, string> = {
  [RECRUITMENT_STATUS.UNCLASSIFIED]: 'Chưa phân loại',
  [RECRUITMENT_STATUS.POTENTIAL]: 'Tiềm năng',
  [RECRUITMENT_STATUS.NOT_POTENTIAL]: 'Không tiềm năng',
  [RECRUITMENT_STATUS.WAITING_ARRIVE]: 'Chờ đến',
  [RECRUITMENT_STATUS.NOT_ARRIVED]: 'Không đến',
  [RECRUITMENT_STATUS.NOT_QUALIFIED]: 'Không đủ tiêu chuẩn',
  [RECRUITMENT_STATUS.FACTORY_FULL]: 'Nhà máy thừa SL',
  [RECRUITMENT_STATUS.ARRIVED]: 'Được vào làm',
  [RECRUITMENT_STATUS.LEFT]: 'Bỏ về',
};
